/* eslint-disable react/require-default-props */
import React, { useRef, useState, useLayoutEffect, useEffect, useContext } from 'react';
import { cn } from '@express-labs/raven-tools';
import PropTypes from 'prop-types';
import ExpressLogo from '../components/ExpressLogo';
import s from './DesktopHeader.module.scss';
import CustomerStore from '../components/CustomerStore';
import StickyHeader from '../components/StickyHeader';
import EvergreenMessage from '../components/EvergreenMessage';
import DesktopNavigation from './subcomponents/DesktopNavigation';
import TenderTypeModal from '../components/TenderTypeModal';
import { ResizeContext } from '../../../contexts/Resize/Resize';
import { scrollStop } from '../../../helpers';

function DesktopHeader({
  displayRewardsToolTip = false,
  storeLocatorHeader,
  isTenderTypePromosEnabled = false
}) {
  const headerRef = useRef();
  const [hideTopHeader, setHideTopHeader] = useState(false);
  const [topPosition, setTopPosition] = useState();
  const stickyHeaderLimited = window?.FLAGS?.StickyHeaderLimited;
  const { width } = useContext(ResizeContext);

  // Todo: Fix memory leak?
  // Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
  // - Matt Toledo 12/22/23
  function getBottomPosition(current) {
    const dimensions = current.getBoundingClientRect();
    return dimensions.top + dimensions.height;
  }

  function handleBottomPositionChange(current) {
    /* Adding a check to ensure that current exists.  This should
    not happen since it is in the layout effect but taking extra caution.
    Ignoring coverage for the else block in coverage because it is unlikely
    and nothing happens if current is not truthy. */
    /* istanbul ignore next */
    if (current) {
      const bottomPosition = getBottomPosition(current);
      setHideTopHeader(bottomPosition <= 0);
      setTopPosition(bottomPosition);
    }
  }

  function debounceOnMouseMove() {
    const { current } = headerRef;
    handleBottomPositionChange(current);
  }

  useEffect(() => {
    debounceOnMouseMove();
  });

  useLayoutEffect(() => {
    const { current } = headerRef;
    /* istanbul ignore next */
    scrollStop(() => handleBottomPositionChange(current));

    document.addEventListener('mousemove', debounceOnMouseMove);
    return () => {
      document.removeEventListener('mousemove', debounceOnMouseMove);
    };
  }, [headerRef]);
  return (
    <>
      <div data-testid="desktop-header" className={s.desktopHeader} ref={headerRef}>
        <div className={s.headerLeft} data-testid="header-left">
          {storeLocatorHeader && <CustomerStore />}
          <EvergreenMessage className={cn(s.message, 'rvnP2')} />
        </div>
        <ExpressLogo />
        <div className={s.headerRight} data-testid="desktop-right">
          {(!stickyHeaderLimited || (stickyHeaderLimited && !hideTopHeader))
      && (
        <StickyHeader
          displayRewardsToolTip={displayRewardsToolTip}
          hideTopHeader={hideTopHeader}
          topPosition={topPosition}
        />
      )}
        </div>
      </div>
      <DesktopNavigation
        hideTopHeader={hideTopHeader}
        topPosition={topPosition}
      />
      { isTenderTypePromosEnabled && (
      <TenderTypeModal
        deviceWidth="desktop"
        windowWidth={width}
        topPosition={topPosition}
        hideTopHeader={hideTopHeader}
      />
      )}
    </>
  );
}

DesktopHeader.propTypes = {
  storeLocatorHeader: PropTypes.bool.isRequired,
  displayRewardsToolTip: PropTypes.bool,
  isTenderTypePromosEnabled: PropTypes.bool,
};

export default DesktopHeader;
